import { TTagsManager } from '../../types/tag';
import { getRangeValue, resetTerms } from '../../../../JsonQuery';

const ID = 'balcony';

export const balconyTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const balconies = getRangeValue('balconies')(jsonQuery);

    return Number(balconies?.gte) > 0 ? [{ label: 'Есть балкон', value: ID }] : null;
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['balconies'])(jsonQuery),
};
